import { render, staticRenderFns } from "./AttachmentCentres.vue?vue&type=template&id=35520cf8"
import script from "./AttachmentCentres.vue?vue&type=script&lang=js"
export * from "./AttachmentCentres.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCentres.vue?vue&type=style&index=0&id=35520cf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports